import React, { useRef, useState } from 'react';
import { projectService } from '../../services/projectService';
import { Heading } from '../ui';

/**
 * A design project's notes (moved out of ProjectDetail for the books desk's
 * phase 3b): one field, `projects/{id}.notes` — the one the iOS app and the
 * crew's rules use — saved 1.5 s after the typing stops.
 */
export default function ProjectNotesTab({ projectId, initialNotes, canEdit }) {
  const [notesText, setNotesText] = useState(initialNotes);
  const [savingNotes, setSavingNotes] = useState(false);
  const [notesSaved, setNotesSaved] = useState(false);
  const notesTimerRef = useRef(null);
  const notesSavedTimerRef = useRef(null);

  const handleNotesChange = (value) => {
    setNotesText(value);
    setNotesSaved(false);
    if (notesTimerRef.current) clearTimeout(notesTimerRef.current);
    notesTimerRef.current = setTimeout(async () => {
      try {
        setSavingNotes(true);
        await projectService.updateProject(projectId, { notes: value });
        setSavingNotes(false);
        setNotesSaved(true);
        // Clear "Saved" after 3 seconds
        if (notesSavedTimerRef.current)
          clearTimeout(notesSavedTimerRef.current);
        notesSavedTimerRef.current = setTimeout(
          () => setNotesSaved(false),
          3000
        );
      } catch (err) {
        console.error('Failed to save notes:', err);
        setSavingNotes(false);
      }
    }, 1500);
  };

  return (
    <section className="content-section">
      <Heading level={3} tone="dark">
        Project Notes
      </Heading>
      <div className="project-notes">
        <textarea
          className="project-notes__textarea"
          value={notesText}
          onChange={(e) => handleNotesChange(e.target.value)}
          placeholder="Add project notes, scope description, or any other information..."
          disabled={!canEdit}
        />
        <div className="project-notes__save-status">
          {savingNotes && 'Saving...'}
          {notesSaved && !savingNotes && 'Saved'}
        </div>
      </div>
    </section>
  );
}
